export default class File {

    constructor(data) {
        this.hash = '';
        this.path = '';
        this.public_path = '';

        Object.assign(this, data);
    }

    getPathForSize(width, height) {
        let path = this.public_path.split('/');
        path.splice(2,0, `a${width}x${height}`);

        return path.join('/');
    }

}
